export default "__VITE_ASSET__DvWJJ1aq__"